/*
 * @Author: huangzq
 * @Date: 2020-01-19 16:16:59
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-08-06 10:36:36
 * @Desc: 规则+标签设置 统一组件
*/
<template>
  <div class="tag-rules">
    <!-- 标签规则-对应的提示 -->
    <div class="tag-rules-tip">
      <div class="frist-tip">
        <i class="el-icon-warning"></i>
        <p>微信用户访问页面时，当满足符合的条件，会给他打上所设置的行为标签。</p>
      </div>
      <div class="second-tip">
        <p>多个标签规则同时存在时，标签会进行累加。</p>
        <p
          v-if="canSetTag"
          class="set-tag cursor"
          @click="isShowSetTagDrawer=true"
        >
          没有标签？立刻设置
          <i class="el-icon-arrow-right el-icon--right">
          </i>
        </p>
      </div>
    </div>
    <!-- 规则 -->
    <div
      v-if="isLoading"
      v-loading="isLoading"
      class="loading-box"
    />
    <div
      v-else
      ref="rules-content"
      class="rules-content"
      :class="isScroll ? 'tags-box-scroll' : ''"
    >
      <div
        v-for="(rulesItem,index) in rulesList"
        :key="index"
        :value="rulesList"
        class="tag-select-rules"
        v-bind="$attrs"
      >
        <span class="px-5 title">{{ index + 1 }}. 微信用户</span>
        <mk-select
          v-model="rulesItem.event"
          :value="rulesItem"
          placeholder="选择触发条件"
          width="240"
          @change="selectCondition(rulesItem, index)"
        >
          <mk-option
            v-for="conditionItem in rulesCondition"
            :key="conditionItem.event"
            :label="conditionItem.showName"
            :value="conditionItem.event"
          >
          </mk-option>
        </mk-select>
        <span class="px-5">时，</span>
        <!-- 标签组件 -->
        <tag-select
          :key="tagSelectKey"
          v-model="rulesItem.tags"
          :tip="false"
          :tag-enable-list="tagEnableList"
          width="260"
          class="tag-select-components"
          @change="onChange"
        />
        <span class="px-5">加上</span>
        <mk-input-number
          v-model="rulesItem.score"
          controls-position="right"
          size="small"
          :min="1"
          :max="100"
          width="90"
          step-strictly
          @change="onChange"
        />
        <span class="px-5">分</span>
        <!-- 规则增减 -->
        <div class="rules-operation">
          <!-- 减 -->
          <div
            v-if="rulesList.length>1"
            class="el-icon-minus-btn"
            @click.prevent="removeRules(rulesItem)"
          >
            <i
              class="el-icon-minus"
            ></i>
          </div>

          <!-- 加 -->
          <div
            v-if="!isAllReprint && index+1===rulesList.length&&rulesList.length<10"
            class="el-icon-plus-btn"
            @click="addRules"
          >
            <i
              class="el-icon-plus"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 设置标签侧弹窗 -->
    <template v-if="canSetTag">
      <set-tag-drawer
        :visible.sync="isShowSetTagDrawer"
        @on-close="handelOnSetTagDrawerClose"
      ></set-tag-drawer>
    </template>
  </div>
</template>

<script>
import tagSelect from '@components/tag-select'
import setTagDrawer from '@components/set-tag-drawer'

export default {
  name: 'TagRules',
  components: { tagSelect, setTagDrawer },
  model: { event: 'change' },
  props: {
    rulesData: {
      type: Object,
      default () {
        return []
      }
    },
    isScroll: {
      type: Boolean,
      default: false
    },
    // * 当前规则设置的类型：article(文章)、circleFriends(朋友圈)、form(表单)
    type: {
      type: String,
      default: ''
    },
    isAllReprint: {
      // 是否是任意转载链接
      type: Boolean,
      default: false
    },
    canSetTag: {
      // 是否显示-设置标签
      type: Boolean,
      default: true
    },
    isCheck: {
      // 是否需要验证标签是否为空
      type: Boolean,
      default: true
    },
    checkTip: {
      type: String,
      default: '请为每一条标签规则 选择标签'
    },
    // 当前组件需要的接口
    apis: {
      type: Object,
      default: () => {
        return {
          // 获取规则-【预设条件】接口
          materialConfigGet: BIZAPIS.FormApi.materialConfigGet,
          // 获取可用标签
          v1TagEnableGet: WXTAGAPIS.TagApi.v1TagEnableGet
        }
      }
    }
  },
  data () {
    return {
      // * 规则【预设条件】列表可选性
      rulesCondition: [],
      // * 规则数组
      rulesList: [],
      // 【预设条件】选中对象
      curCondition: {},
      // 【停留时间】比较符
      options: '',
      // 规则数据加载loading
      isLoading: false,
      // 标签选择对应的key
      tagSelectKey: Number(new Date().getTime()),
      /**
      规则对应的预设分值
      1分（访问了页面）、2分（停留超过20S）、
      3分（浏览到了最后（触底、播放完成、查看到了最后一页））、
      5分（转发了页面）、10分（提交了表单）
       *
       */
      rulesScore: {
        1: ['enterPage'],
        2: ['stay'],
        3: ['scrollBottom', 'turnLastPage', 'browseEnd'],
        5: ['share'],
        10: ['submitForm']
      },
      // 是否显示标签设置弹窗
      isShowSetTagDrawer: false,
      // 当前可用的标签数据
      tagEnableList: []
    }
  },
  created () {
    this.showRules()
  },
  methods: {
    // 初始化，规则回显
    async showRules (needAdd = true) {
      this.isLoading = true
      if (this.rulesCondition.length === 0) await this.rulesConfigGet()
      if (this.rulesData.rules.length) {
        this.handelRuleByEnableTag()
      } else {
        if (needAdd) this.addRules()
        this.$nextTick(() => {
          this.isLoading = false
        })
      }
    },
    // 获取可用标签
    async tagEnableGet () {
      const res = await this.apis.v1TagEnableGet()
      if (res.success) {
        this.tagEnableList = res.data
      }
    },
    // 通过【可用标签】来处理对应规则里面的标签
    async handelRuleByEnableTag () {
      await this.tagEnableGet()
      const len = this.tagEnableList.length
      // 可用标签的id数组
      const enableTagIdArray = []
      for (let index = 0; index < len; index++) {
        const item = this.tagEnableList[index]

        const childrenLen = item.children.length

        if (childrenLen) {
          enableTagIdArray.push(...item.children)
        }
      }

      const rulesData = this._.cloneDeep(this.rulesData)

      this.util.rulesTagRemoveForbidden(rulesData.rules, enableTagIdArray)

      this.rulesList = rulesData.rules

      this.$nextTick(() => {
        this.isLoading = false
      })
    },

    // 获取规则-【预设条件】接口
    async rulesConfigGet () {
      const res = await this.apis.materialConfigGet({
        name: 'tag_rule_config',
        materialType: this.type
      })
      if (res.success) {
        let backdata = res.data.rules
        backdata.map((item, index) => {
          // 停留时长
          if (item.config.operator) {
            if (item.config.operator === 'gte') {
              //   大于等于
              this.options = '>='
            }
            item.showName = `${item.showName}${this.options}${item.config.threshold}秒`
            return item
          }
          // 不需要“提交表单”
          if (item.event === 'submitForm' && this.type !== 'form') {
            backdata.splice(index, 1)
          }
        })
        if (this.isAllReprint) {
          this.rulesCondition = [backdata[0]]
        } else {
          this.rulesCondition = backdata
        }
      }
    },
    // 新增规则
    addRules () {
      let itemCondition = this.rulesCondition.find(item => {
        return item.event === 'enterPage'
      })
      let params = {
        event: 'enterPage',
        tags: [],
        score: '',
        config: itemCondition.config,
        triggerType: itemCondition.triggerType,
        showName: itemCondition.showName
      }
      this.rulesList.push(params)
      // 滚动条到底部
      this.$nextTick(() => {
        let rulesListContent = this.$refs['rules-content']
        if (rulesListContent) {
          rulesListContent.scrollTop = rulesListContent.scrollHeight
        }
        this.isLoading = false
        this.$emit('change', this._.cloneDeep(this.rulesList))
      })
    },
    // 规则删除
    removeRules (item) {
      this.tagSelectKey = Number(new Date().getTime())
      var index = this.rulesList.indexOf(item)
      if (index !== -1) {
        this.rulesList.splice(index, 1)
      }
      this.$emit('change', this._.cloneDeep(this.rulesList))
    },
    // 获取当前规则条件
    selectCondition (rulesItem, index) {
      this.curCondition = this.rulesCondition.find(item => {
        return item.event === rulesItem.event
      })
      this.rulesList[index].showName = this.curCondition.showName
      this.rulesList[index].triggerType = this.curCondition.triggerType
      this.rulesList[index].config = this.curCondition.config
      this.rulesList[index].score = this.getScoreByRule(this.curCondition)

      this.onChange()
    },

    // 通过规则获取对应的预设分值
    getScoreByRule (rule = null) {
      let score = 1
      if (rule) {
        for (const key in this.rulesScore) {
          if (this.rulesScore.hasOwnProperty(key)) {
            const element = this.rulesScore[key]
            if (element.includes(rule.event)) {
              score = Number(key)
            }
          }
        }
      }
      return score
    },
    // 提交至父级
    onChange () {
      this.$emit('change', this._.cloneDeep(this.rulesList))
    },
    // 标签设置弹窗-关闭事件
    handelOnSetTagDrawerClose () {
      this.showRules(false)
    },
    /**
     * * 检测标签规则中标签必填，每添加一条规则，标签都必选
     */
    checkTagRules () {
      if (this.rulesList.length) {
        let index = this.rulesList.findIndex(item => item.tags.length === 0)
        return index === -1
      } else {
        return false
      }
    },
    doCheck () {
      if (!this.isCheck) {
        return true
      } else {
        const res = this.checkTagRules()
        if (res) {
          return true
        } else {
          this.$message.error(this.checkTip)
          return false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-rules {
  max-width: 750px;

  .tag-rules-tip {
    margin: 10px 0 15px;
    padding: 10px;
    color: #262626;
    font-size: 14px;
    background: rgba(242, 251, 255, 1);
    border-radius: 4px;
    border: 1px solid #ccecff;
    line-height: 20px;

    .frist-tip {
      display: flex;
      align-items: center;

      .el-icon-warning {
        margin-right: 10px;
        color: #009cff;
        font-size: 16px;
      }
    }

    .second-tip {
      display: flex;
      justify-content: space-between;
      margin-left: 26px;

      .set-tag {
        font-size: 13px;
        color: #009cff;
      }
    }
  }

  .loading-box {
    height: 240px;
  }

  .rules-content {
    .tag-select-rules {
      display: inline-block;
      width: 100%;
      box-sizing: border-box;
      padding: 0 16px 10px 16px;
      margin-bottom: 10px;
      border: 1px solid #d6d6d6;
      border-radius: 4px;
      position: relative;
      overflow: hidden;
      line-height: 40px;

      .px-5 {
        margin: 0 10px;
        font-size: 13px;
        color: #3d3d3d;
      }

      .title {
        margin: 0;
        display: block;
        font-weight: 500;
      }

      .tag-select-components {
        display: inline-block;
      }

      .rules-operation {
        padding-left: 20px;
        display: inline-flex;
        position: absolute;
        top: 0;
        right: 0;
        border-radius: 0 0 0 4px;
        overflow: hidden;

        .el-icon-minus {
          margin-left: 10px;
        }

        .el-icon-minus-btn,
        .el-icon-plus-btn {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #dadada;
          cursor: pointer;
          border-top: none;
          border-right: none;
          background-color: #f8f8f8;
        }

        /deep/ .el-icon-minus::before,
        .el-icon-plus::before {
          font-size: 15px;
          cursor: pointer;
        }

        /deep/ .el-icon-minus::before {
          color: #b5b5b5;
          margin-right: 10px;
        }

        /deep/ .el-icon-plus::before {
          color: #b5b5b5;
        }
      }
    }
  }

  .tags-box-scroll {
    max-height: 320px;
    overflow-y: auto;
  }
}
</style>
